import React from 'react'

const Blog = () => {
    return (<section id="blog">blog</section>)
}

export default Blog